import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowTriangleBottom: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowTriangleBottom"><Path d="M3.37988 4H20.616L11.9979 21.2361L3.37988 4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowTriangleBottom;
